// extracted by mini-css-extract-plugin
module.exports = {"container":"TableUserActions_container__3ohVo","link":"TableUserActions_link__2aSy1"};